// extracted by css-extract-rspack-plugin
export default {"arrow":"cxl6QwIyVoQDBDaI"};